import { render, staticRenderFns } from "./ItemCodePage.vue?vue&type=template&id=54d42a23"
import script from "./ItemCodePage.vue?vue&type=script&lang=js"
export * from "./ItemCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports